// Coerces an unknown value to a usable number: anything that does not parse to
// a finite number (undefined, NaN, Infinity, non-numeric strings, objects)
// falls back. Note the Number() semantics — null and '' coerce to 0, not to the
// fallback. Unlike parseNumberValue/resolveNumberValue this never returns
// null/undefined, so callers that need a guaranteed number use this one.
export const toFiniteNumber = (value: unknown, fallback: number): number => {
  const parsed = typeof value === 'number' ? value : Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};
